import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import { Section } from "@/components/Section";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/blogs/${slug}`).then((r) => setPost(r.data)).catch(() => setErr("Article not found"));
  }, [slug]);

  if (err) return <Section className="py-32 text-center"><h2 className="font-heading font-black text-3xl">{err}</h2><Link to="/blog" className="btn-outline mt-6 inline-flex">Back to Blog</Link></Section>;
  if (!post) return <Section className="py-32"><div className="skeleton h-96" /></Section>;

  return (
    <>
      <section className="bg-[#1A1A1A] text-white py-16 noise-overlay">
        <Section>
          <Link to="/blog" className="text-xs uppercase tracking-widest text-gray-400 hover:text-[#FFCC00] inline-flex items-center gap-2"><ArrowLeft className="w-3 h-3" /> Back to Blog</Link>
          <div className="mt-6 label-eyebrow">{post.category}</div>
          <h1 className="heading-xl text-3xl sm:text-4xl lg:text-5xl mt-3 max-w-4xl">{post.title}</h1>
          <div className="text-sm text-gray-400 mt-4">By {post.author}</div>
        </Section>
      </section>

      <Section className="py-12">
        {post.cover_image && <img src={mediaUrl(post.cover_image)} alt={post.title} className="w-full max-h-[500px] object-cover" />}
        <div
          className="prose prose-lg max-w-3xl mx-auto mt-12 prose-headings:font-heading prose-headings:uppercase prose-headings:tracking-tight prose-h2:text-3xl prose-h2:font-black prose-h3:text-xl prose-h3:font-bold prose-a:text-[#E65C00] prose-strong:text-[#1A1A1A]"
          dangerouslySetInnerHTML={{ __html: post.content }}
          data-testid="blog-content"
        />
      </Section>
    </>
  );
}
